import { useState, useCallback } from 'react';

/**
 * Custom hook to manage product card loading states
 * This tracks which messages have product cards that are loading
 */
export const useProductCardLoading = () => {
  // Track which messages have product cards that are still loading
  const [productCardsLoading, setProductCardsLoading] = useState<Record<string, boolean>>({});

  // Mark a message as having its product cards loading
  const setMessageLoading = useCallback((messageId: string) => {
    setProductCardsLoading(prev => ({
      ...prev,
      [messageId]: true
    }));
  }, []);

  // Mark a message as having its product cards loaded
  const setMessageLoaded = useCallback((messageId: string) => {
    setProductCardsLoading(prev => ({
      ...prev,
      [messageId]: false
    }));
  }, []);

  // Check if a message's cards are loading
  const isMessageLoading = useCallback((messageId: string) => {
    return productCardsLoading[messageId] || false;
  }, [productCardsLoading]);

  return {
    productCardsLoading,
    setMessageLoading,
    setMessageLoaded,
    isMessageLoading
  };
};
